import Numbers from "@src/components/numbers"
import createPage from "@src/components/page"
import { byToday, parseDate } from "@src/utils/data-parser"
import React from "react"
import * as styles from "./pageJoin.module.scss"
import yearImg from "@images/png/3.png"
import monthImg from "@images/png/4.png"
import dateImg from "@images/png/5.png"
import dayImg from "@images/png/25.png"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "@react-spring/web"
import classnames from "@src/utils/classnames"
import { whiteColor } from "@config"

const parseData = (data) => {
  const parsed = {
    created: {
      ...parseDate(),
    },
    total: "0000",
  }
  try {
    const createdStr = data.user.attributes["created-at"]
    parsed.created = parseDate(createdStr)
    parsed.total = byToday(createdStr)
  } catch (e) {}
  return parsed
}

const PageJoin = createPage(
  ({ data, offset }) => {
    const parsedData = parseData(data)
    const anime1Styles = useEnteringTrail(1, offset)
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.4 })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.8 })
    return (
      <>
        <animated.div className={styles.top} style={anime1Styles[0]}>
          <div className={styles.flexEnd}>
            <Numbers>{parsedData.created.year}</Numbers>
            <img src={yearImg} className={styles.unit} alt="年" />
          </div>
          <div className={classnames(styles.topPadding)}>
            <div className={classnames("line1", styles.flexEnd, styles.mdLine)}>
              <div className={styles.flexEnd}>
                <Numbers>{parsedData.created.month}</Numbers>
                <img src={monthImg} className={styles.unit} alt="月" />
              </div>
              <div className={styles.flexEnd}>
                <Numbers>{parsedData.created.date}</Numbers>
                <img src={dateImg} className={styles.unit} alt="日" />
              </div>
            </div>
            <div>{callYou(data)}来到机核</div>
          </div>
        </animated.div>

        <animated.div className={styles.bottom} style={anime2Styles[0]}>
          <div className="line1">感谢与{callYou(data)}同行的</div>
          <div className={styles.flexEnd}>
            <Numbers>{parsedData.total}</Numbers>
            <img src={dayImg} className={styles.unit} alt="天" />
          </div>
        </animated.div>

        <animated.div className="bottomText" style={anime3Styles[0]}>
          机核上线于2010年5月12日
          <br />
          至2022年1月1日，已运营4252天
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  }
)

export const pageJoinData = {
  key: "join",
  bg: whiteColor,
  bgElement: (
    <>
      <div className={styles.joinPageBgHalf}></div>
      <div className={styles.joinPageBgHalfPolygon}></div>
    </>
  ),
  Page: PageJoin,
}

export default PageJoin
